import { useNavigate } from "react-router-dom";
import { PrimaryButton } from "../../components/buttons/PrimaryButton";
import { SecondaryButton } from "../../components/buttons/SecondaryButton";
import Form from "../../components/inputs/Form";
import Header from "../../components/layout/Header";
import { Page, PageBody, PageHeader } from "../../components/layout/Page";
import { backArrow, save } from "../../assets/icons";
import Card from "../../components/card/Card";
import "./etalon.css";
import { useState } from "react";
import { createRecord } from "../../server/fetchFunctions";
import { Data } from "../../lib/typeDeclarations";
import { pattern } from "../../lib/pattern";
import { TextInput } from "../../components/inputs/TextInput";
import { DateInput } from "../../components/inputs/Datepicker";

export default function NewEtalon() {
  document.title = "Új etalon";
  const navigate = useNavigate();

  const [etalon, setEtalon] = useState<Data>({
    type: "",
    description: "",
    manufacturer: "",
    serial_no: "",
    cal_number: "",
    last_calibration: "",
    cal_frequency: "",
  });

  //Functions

  const saveEtalon = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const response = await createRecord("etalon", etalon);
    navigate(`/etalons/${response.id}`);
  };

  return (
    <Page>
      <Form onSubmit={e => saveEtalon(e)}>
        <Header>
          <SecondaryButton
            btn={{ svgBefore: backArrow, text: "Vissza", onClick: () => navigate(-1) }}
          />
          <PrimaryButton btn={{ svgBefore: save, text: "Ment", type: "submit" }} />
        </Header>
        <PageHeader title="Új etalon rögzítése" />
        <PageBody>
          <div className="device">
            <div className="col-1">
              <Card title="Etalon">
                <TextInput
                  stateKey="type"
                  inlineLabel="Típus"
                  state={etalon}
                  setState={setEtalon}
                  pattern={pattern.normal_text}
                  labelWidth={220}
                  required
                />
                <TextInput
                  stateKey="manufacturer"
                  inlineLabel="Gyártó"
                  state={etalon}
                  setState={setEtalon}
                  pattern={pattern.normal_text}
                  labelWidth={220}
                  required
                />

                <TextInput
                  stateKey="description"
                  inlineLabel="Megnevezés"
                  state={etalon}
                  setState={setEtalon}
                  pattern={pattern.normal_text}
                  labelWidth={220}
                  required
                />
                <TextInput
                  stateKey="serial_no"
                  inlineLabel="Gyári szám"
                  state={etalon}
                  setState={setEtalon}
                  pattern={pattern.normal_text}
                  labelWidth={220}
                  required
                />
                <TextInput
                  stateKey="cal_number"
                  inlineLabel="Kalibrálási szám"
                  state={etalon}
                  setState={setEtalon}
                  pattern={pattern.normal_text}
                  labelWidth={220}
                  required
                />
                <DateInput
                  state={etalon}
                  setState={setEtalon}
                  stateKey="last_calibration"
                  inlineLabel="Utolsó kalibrálás dátuma"
                  labelWidth={220}
                  required
                />
                <TextInput
                  stateKey="cal_frequency"
                  inlineLabel="Kalibrálási gyakoriság"
                  state={etalon}
                  setState={setEtalon}
                  pattern={pattern.number}
                  format="toNumber"
                  labelWidth={220}
                  required
                />
              </Card>
            </div>
          </div>
        </PageBody>
      </Form>
    </Page>
  );
}
